import app from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/storage';

class Firebase {
    constructor(props) {
      let config = props.config;
      //let data = require(`./${login}.json`);
      app.initializeApp(config);
      this.auth = app.auth();
      this.bd = app.database();
      this.storage = app.storage();
      this.deleteSessions = () => {
         app.app().delete();
      }
    }

    doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => {
      this.auth.signOut();
      this.deleteSessions();
    };

 
  }

export default Firebase;
